/* eslint-disable react/jsx-no-bind */
// @flow
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Columns, Button, Heading, Box, Flex } from '@locus-taxy/neo-ui';

type Props = {
    product: string,
    onSave: () => void,
    isSaving: boolean,
    disableSave: boolean
};

const Header = ({ product, onSave, disableSave, isSaving }: Props) => {
    const { t } = useTranslation('platform');

    return (
        <Box
            width="100%"
            paddingY={4}
            paddingX={4}
            backgroundColor="white"
            boxShadow="active"
            sx={{ zIndex: 10 }}
        >
            <Flex justifyContent="space-between" alignItems="center">
                <Heading>{t(`settings.products.${product}`)}</Heading>
                <Columns space="medium">
                    <Button
                        palette="primary"
                        appearance="solid"
                        onClick={() => onSave()}
                        isLoading={isSaving}
                        disabled={disableSave}
                        data-test-id="btn-save"
                    >
                        {t('save')}
                    </Button>
                </Columns>
            </Flex>
        </Box>
    );
};

export default Header;
